import { memo, useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { useFetchCampaignsPlatformLabelData } from './hooks/useFetchCampaignsPlatformLabelData';
import CampaignsShowMoreButtonPopover from './campaignsPlatformLabel/CampaignsShowMoreButtonPopover';
import CampaignLabelWithPopover from './campaignsPlatformLabel/CampaignLabelWithPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_MAX_VISIBLE_CAMPAIGNS = 3;
const DefaultHeaderComponent = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  typography: "heading-50",
  children: children
});
function CampaignsPlatformLabel({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id',
  HeaderComponent = DefaultHeaderComponent,
  as = 'tag',
  inline = false,
  withEmptyState = true,
  maxVisibleCampaigns = DEFAULT_MAX_VISIBLE_CAMPAIGNS
}) {
  var _associationMetadata$;
  const {
    hasAssociationSettings,
    associatedCampaigns,
    associationMetadata,
    loading
  } = useFetchCampaignsPlatformLabelData({
    objectType,
    assetId,
    crmIdProperty
  });
  const visibleCampaigns = useMemo(() => associatedCampaigns.slice(0, maxVisibleCampaigns), [associatedCampaigns, maxVisibleCampaigns]);
  const assetLabel = associationMetadata === null || associationMetadata === void 0 || (_associationMetadata$ = associationMetadata.assetNameWithVariant) === null || _associationMetadata$ === void 0 || (_associationMetadata$ = _associationMetadata$.value) === null || _associationMetadata$ === void 0 || (_associationMetadata$ = _associationMetadata$.inSentenceLabel) === null || _associationMetadata$ === void 0 ? void 0 : _associationMetadata$.singular;
  const shouldNotRender = loading || !hasAssociationSettings || !withEmptyState && associatedCampaigns.length === 0;
  if (shouldNotRender) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "campaigns-platform-label",
    "data-test-inline": inline,
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: inline ? 'row' : 'column',
      display: inline ? 'inline-flex' : 'flex',
      flexWrap: inline ? 'wrap' : 'nowrap',
      gap: inline ? '200' : '0',
      children: [/*#__PURE__*/_jsx(HeaderComponent, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.formControlLabel",
          options: {
            count: associatedCampaigns.length
          }
        })
      }), associatedCampaigns.length === 0 ? /*#__PURE__*/_jsx("span", {
        "data-test-id": "empty-campaigns-platform-label",
        children: "-"
      }) : visibleCampaigns.map(campaign => /*#__PURE__*/_jsx(CampaignLabelWithPopover, {
        as: as,
        objectType: objectType,
        campaign: campaign
      }, campaign.objectId))]
    }), associatedCampaigns.length > maxVisibleCampaigns && /*#__PURE__*/_jsx(CampaignsShowMoreButtonPopover, {
      assetLabel: assetLabel,
      objectType: objectType,
      campaigns: associatedCampaigns
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformLabel);